module.exports = __webpack_public_path__ + "img/cubs.05b42ba2.svg";